export default __webpack_public_path__ + "static/media/Inter-UI-Medium.bc5220d2.woff";